import React from 'react';
import { DatePicker, ConfigProvider } from 'antd';
import { DatePicker as DatePickerFormik } from 'formik-antd';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import ptBR from 'antd/es/locale/pt_BR';
import 'dayjs/locale/pt-br';

dayjs.extend(customParseFormat);
dayjs.locale('pt-br');

const DateComponent = ({
  label,
  value,
  onChange,
  onBlur = () => {},
  onOk = () => {},
  showTime = true,
  name = false,
  ...props
}) => {
  const format = `DD/MM/YYYY${showTime ? ' HH:mm' : ''}`;
  const dateOnlyFormat = 'DD/MM/YYYY';
  const placeholder = `Digite ou selecione a data${showTime ? ' e hora' : ''}`;
  const parsedValue = value ? dayjs(value) : null;

  const handleChange = (date) => {
    if (date && date.isValid()) {
      onChange(date.format('YYYY-MM-DDTHH:mm:ss'));
    } else {
      onChange(null);
    }
  };

  const parseAndSetDate = (text) => {
    if (!text) return;

    let parsed = dayjs(text, format, true);

    if (!parsed.isValid() && showTime) {
      const dateOnly = dayjs(text, dateOnlyFormat, true);
      if (dateOnly.isValid()) {
        parsed = dateOnly.hour(0).minute(0).second(0);
      }
    }

    // Se ainda não funcionou, tenta apenas com data
    if (!parsed.isValid()) {
      parsed = dayjs(text, dateOnlyFormat, true);
    }

    if (parsed.isValid()) {
      onChange(parsed.format('YYYY-MM-DDTHH:mm:ss'));

      return true;
    }
    return false;
  };

  const handleBlur = (e) => {
    const text = e.target.value;
    if (text && text !== parsedValue?.format(format)) {
      parseAndSetDate(text);
    }
    onBlur();
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      const text = e.target.value;
      if (parseAndSetDate(text)) {
        e.target.blur(); // Remove o foco para fechar o picker
      }
    }
  };

  return (
    <div>
      {label && <label>{label}</label>}
      <ConfigProvider locale={ptBR}>
        {name ? (
          <DatePickerFormik
            {...props}
            name={name}
            format={format}
            placeholder={placeholder}
            style={{ width: '100%', display: 'block' }}
            showTime={showTime ? { format: 'HH:mm' } : false}
            inputReadOnly={false}
          />
        ) : (
          <DatePicker
            {...props}
            value={parsedValue}
            format={format}
            placeholder={placeholder}
            style={{ width: '100%', display: 'block' }}
            showTime={showTime ? { format: 'HH:mm' } : false}
            inputReadOnly={false}
            onChange={handleChange}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
            onOk={onOk}
          />
        )}
      </ConfigProvider>
    </div>
  );
};

export default DateComponent;
